<template>
  <div :class="$style.bigWrapper">
    <div :class="$style.wrapper">
      <User
        v-for="user in users"
        :key="user.id"
        :user="user"
      />
    </div>
    <DraggableContainer :error="error === 0" :id="0" title="Соседи" :dropzoneNumber="3" :icon="require('./assets/sosedi.svg')" />
    <DraggableContainer :error="error === 1" :id="1" title="Футбол" :dropzoneNumber="3" :icon="require('./assets/football.svg')" />
    <DraggableContainer :error="error === 2" :id="2" title="Музыка" :dropzoneNumber="2" :icon="require('./assets/music.svg')" />
    <DraggableContainer :error="error === 3" :id="3" title="Литература" :dropzoneNumber="2" :icon="require('./assets/litra.svg')" />

    <transition name="fade">
      <Button wide :class="$style.button" v-if="ready && !isMobile" @click="check">
        Продолжить
      </Button>
    </transition>
  </div>
</template>
<script>
import isEqual from 'lodash/isEqual'

import User from '../User/User.vue'
import DraggableContainer from './components/DraggableContainer/DrabbagleContainer.vue'

import Button from '@/components/@ui/Button/Button.vue'

import Bus from '../../Bus'

const rightUsersGroup = [
  [2, 3, 4].sort(),
  [7, 6, 5].sort(),
  [2, 1].sort(),
  [5, 8].sort(),
]

export default {
  name: 'DraggableUsers',
  props: {
    users: Array,
  },
  data: () => ({
    ready: false,
    result: [],
    error: null,
  }),
  components: { User, DraggableContainer, Button },
  mounted() {
    const { Droppable } = require('@shopify/draggable')
    const container = this.$el

    this.draggable = new Droppable(container, {
      draggable: '.draggable',
      dropzone: '.dropzone',
      mirror: {
        constrainDimensions: true,
        appendTo: 'body',
      },
    })

    this.droppableOrigin = null
    this.sourceDropZone = null

    this.draggable.on('droppable:dropped', (evt) => {
      if (this.droppableOrigin !== evt.dropzone.dataset.zone && evt.dropzone.dataset.zone !== undefined) {
        evt.cancel()
      } else if (evt.dropzone.dataset.result) {
        const draggableID = evt.data.dragEvent.data.source.dataset.id
        const zones = [...document.querySelectorAll(`[data-result="${evt.dropzone.dataset.result}"]`)]
        const ids = zones
          .map(z => z.querySelector('.draggable'))
          .filter(Boolean)
          .map(d => d.dataset.id)
          .filter(Boolean)

        if (ids.includes(draggableID)) evt.cancel()
      }
    })

    this.draggable.on('drag:start', (evt) => {
      const { source } = evt.data
      this.sourceDropZone = source.closest('.dropzone')
      this.droppableOrigin = source.dataset.id
    })

    this.draggable.on('drag:stop', (evt) => {
      const { source } = evt.data

      if (!this.sourceDropZone.dataset.zone) {
        this.sourceDropZone.classList.remove('draggable-dropzone--occupied')
        this.$nextTick()
          .then(() => {
            [...this.sourceDropZone.querySelectorAll('.draggable')].forEach(item => item.remove())
          })
      } else {
        this.sourceDropZone.append(source.cloneNode(true))
      }

      this.$nextTick()
        .then(() => {
          this.calcResults()
        })
    })
  },
  computed: {
    isMobile() {
      return this.$store.state.utils.isMobile
    },
  },
  beforeDestroy() {
    this.draggable.destroy()
  },
  methods: {
    calcResults() {
      this.result = [[], [], [], []]

      const containers = [...document.querySelectorAll('.dropzone[data-result]')]
      const filledContainers = containers.filter(cont => !!cont.querySelector('.draggable'))
      containers.forEach((cont) => {
        const id = parseInt(cont.dataset.result, 10)
        const item = cont.querySelector('.draggable')
        if (item) {
          const itemID = parseInt(item.dataset.id, 10)
          this.result[id].push(itemID)
        }
      })

      Bus.$emit('setUsers', this.result)

      this.ready = filledContainers.length === containers.length
    },
    check() {
      this.error = null
      this.result.forEach((items, index) => {
        const sorted = items.sort()
        const hasError = !isEqual(sorted, rightUsersGroup[index])
        if (this.error === null && hasError) {
          this.error = index
        }
      })
      if (this.error === null) {
        Bus.$emit('usersGroupReady')
      }
    },
  },
}
</script>
<style lang="scss" module>
@import './DraggableUsers.scss';
</style>
